import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Btn.module.css';

/**
 * Tank Redesign primary button atom.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `Btn` function.
 * Variants: primary (phosphor), ghost (border), soft (accent-tinted), danger
 * (red-tinted), quiet (no border). Sizes: xs / sm / md / lg.
 *
 * Lives in shared/components/redesign/ during the migration; will move up to
 * shared/components/ui/ at M6 cleanup once the legacy Button is retired.
 *
 * @param {Object} props
 * @param {'primary'|'ghost'|'soft'|'danger'|'quiet'} [props.kind='primary']
 * @param {'xs'|'sm'|'md'|'lg'} [props.size='md']
 * @param {React.ReactNode} [props.icon]
 * @param {React.ReactNode} [props.iconRight]
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
const Btn = forwardRef(function Btn(
  {
    kind = 'primary',
    size = 'md',
    icon,
    iconRight,
    disabled = false,
    className,
    children,
    ...rest
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={clsx(styles.btn, styles[kind], styles[size], className)}
      {...rest}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
      {iconRight && <span className={styles.iconRight}>{iconRight}</span>}
    </button>
  );
});

export default Btn;
